// Экземпляр QueryClient с настройками по умолчанию для всего приложения

import { QueryClient } from '@tanstack/react-query'

/** Глобальный экземпляр QueryClient */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000, // 1 минута — данные считаются свежими
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})
